export const app = {
	// Auth
	apiUrl: process.env.REACT_APP_API_URL,
	dashboardLogin: process.env.REACT_APP_DASHBOARD,
};

export const getConfigValue = (key) => app[key];
